import React, { JSX, ReactNode } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import { getPath, Paths } from '../utils/paths';
import { Image } from 'mui-image'
import { ImageComponent } from './ImageComponent';

export interface AccordionComponentProps {
  key: string
  title: String;
  content?: String;
  expanded?: boolean;
  headerImage?: String;
  children?: ReactNode;
  onChange?: (event: React.SyntheticEvent, newExpanded: boolean) => void;
} 

export const AccordionComponent = ({ key, title, content, expanded, onChange, headerImage, children }: AccordionComponentProps): JSX.Element => {
    const accordingId = `accordion-id-${key}`;
    const accordingAriaControlsId = `accordion-panel-${key}-content`;
    const headerImagePath = headerImage ? `${headerImage}` : ""; 
    return (
      <Accordion expanded={expanded} onChange={onChange} sx={{ marginBottom: "16px", marginTop: "16px" }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls={accordingAriaControlsId}
          id={accordingId}
          sx={{ marginBottom: "0px" }}
        >
          <>
            {headerImagePath && (
              <ImageComponent
                imageSrc={headerImagePath}
                imageProps={{
                  maxWidth: "100px",
                  height: "1.5rem",
                  maxHeight: "30px",
                  //maxWidth: "100px"
                  //paddingTop: "5px"
                  //padding: "10px 0px"
                  marginTop: "8px"
                }}
                variant='whitebackground'
              />
            )}
            <Typography component="span" sx={{ fontSize: "25px", fontWeight: "600" }}>{title}</Typography>
          </>  
        </AccordionSummary>
        <AccordionDetails>
          {children ? children : content}
        </AccordionDetails>
      </Accordion>
    )
};